// extracted by mini-css-extract-plugin
export default {"post":"PostCard_post__SSYD7","capa":"PostCard_capa__zKMPZ","titulo":"PostCard_titulo__cEoQc","botaoLer":"PostCard_botaoLer__5CXpv"};